import { AxiosResponse } from "axios";
import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getAllPassages = (passageData) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_PASSAGE_ALL, {
    params: {
      GradeId: passageData.filterGradeId,
      Title: passageData.filterTitle,
      Citation: passageData.filterCitation,
      PassageDateTypeId: passageData.filterDataType,
      PassageDifficultyTypeId: passageData.filterDifficulty,
      PassageGrammarTypeId: passageData.filterGrammar,
      PassageLiteratureTypeId: passageData.filterLiterature,
      PassageSourceTypeId: passageData.filterSourceType,
      PassageCategoryOldTypeId: passageData.filterCategoryOld,
      PassageCategoryId: passageData.filterCategory,
      OrderByColumn: passageData.orderByColumn,
      SortDir: passageData.sortByDesc,
      PageSize: passageData.pageSize,
      PageNumber: passageData.pageNumber,
      IsApproved: passageData.isApproved,
      IsActive: passageData.isActive,
      passageId: passageData.passageId,
      passageClassificationId: passageData.passageClassificationId,
      tagIds: passageData.tagIds,
      passageTypeId: passageData.filterPassageTypeId,
      englishPassageText: passageData.filterEnglishPassageText,
    },
  });
};

export const getPassagesCategoryOld = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_PASSAGE_CAT_OLD_TYPE, {
    headers: {
      "x-requested-with": "XMLHttpRequest",
    },
  });
};
export const getPassagesCategory = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_PASSAGE_CATEGORIES, {
    headers: {
      "x-requested-with": "XMLHttpRequest",
    },
  });
};
export const getPassagessourceType = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_PASSAGESOURCETYPE, {
    headers: {
      "x-requested-with": "XMLHttpRequest",
    },
  });
};
export const getPassagesdifficultyType = () => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_PASSAGEdIFFICULTYTYPE,
    {
      headers: {
        "x-requested-with": "XMLHttpRequest",
      },
    }
  );
};
export const getPassagesliteratureType = () => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_PASSAGELITERATURETYPE,
    {
      headers: {
        "x-requested-with": "XMLHttpRequest",
      },
    }
  );
};
export const getPassagesDataType = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_PASSAGEDATATYPE, {
    headers: {
      "x-requested-with": "XMLHttpRequest",
    },
  });
};
export const getPassagesGrammarType = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_PASSAGEGRAMMARTYPE, {
    headers: {
      "x-requested-with": "XMLHttpRequest",
    },
  });
};

export const postPassage = async (passageData: any): Promise<AxiosResponse> => {
  const response: AxiosResponse = await AxiosHelper.axiosInstance().post(
    APIConstant.CMS_PASSAGE,
    passageData,
    {
      headers: {
        "x-requested-with": "XMLHttpRequest",
      },
    }
  );

  return response;
};

export const updatePassage = (updatedPassageData) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_PASSAGE,
    updatedPassageData,
    {
      headers: {
        "x-requested-with": "XMLHttpRequest",
      },
    }
  );
};
export const deletePassage = (passageId, userId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_PASSAGE, {
    headers: {
      "x-requested-with": "XMLHttpRequest",
    },
    params: {
      id: passageId,
      userId: userId,
    },
  });
};

export const getAssociatePassage = (
  passageId: string,
  pageSize: number,
  pageNumber: number,
  destinationPassageId?: string
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTION_ALL, {
    headers: {
      "x-requested-with": "XMLHttpRequest",
    },

    params: {
      PassageId: passageId,
      OrderByColumn: "QuestionId",
      IsActive: true,
      SortDir: "Asc",
      PageSize: pageSize,
      PageNumber: pageNumber,
      destinationPassageId: destinationPassageId,
    },
  });
};

export const postPassageQuestion = (questionData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_PASSAGEPOSTQUESTION,
    questionData,
    {
      headers: {
        "x-requested-with": "XMLHttpRequest",
      },
    }
  );
};

export const deleteAssociateQuestion = (
  passageId,
  questionId,
  userId,
  englishQuestionRefId,
  spanishQuestionRefId,
  englishPassageRefId,
  spanishPassageRefId
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_PASSAGEDELETEQUESTION,
    {
      data: {
        passageId: passageId,
        questionId: questionId,
        userId: userId,
        englishQuestionReferenceId: englishQuestionRefId,
        spanishQuestionReferenceId: spanishQuestionRefId,
        englishPassageReferenceId: englishPassageRefId,
        spanishPassageReferenceId: spanishPassageRefId,
      },
    }
  );
};

export const getPassageById = (id) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_PASSAGEBYID}/${id}`
  );
};

export const getAuthours = () => {
  return AxiosHelper.axiosInstance().get(`${APIConstant.CMS_AUTHOUR}`);
};

export const getAllTags = () => {
  return AxiosHelper.axiosInstance().get(`${APIConstant.CMS_TAG_ALL}`, {
    params: {
      PageNumber: 1,
      pageSize: 10000,
      OrderbyColumn: "name",
      sortDir: "Asc",
      isActive: true,
    },
  });
};

export const getPassageTag = (id) => {
  return AxiosHelper.axiosInstance().get(`${APIConstant.CMS_PASSAGETAG}/${id}`);
};

export const postPassageTag = (Tag) => {
  return AxiosHelper.axiosInstance().post(APIConstant.CMS_PASSAGETAG, Tag, {});
};

export const deletePassageTag = (tag) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_PASSAGETAG, {
    params: { PassageId: tag.passageId, TagId: tag.tagId },
  });
};

export const getAssociatePassageByQuestionId = (questionId, userId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_PASSAGE_BY_QUESTION_ID,
    {
      headers: {
        "x-requested-with": "XMLHttpRequest",
      },
      params: {
        questionId: questionId,
        userId: userId,
      },
    }
  );
};

export const getClassifications = () => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_PASSAGE_CLASSIFICATION}`
  );
};
